import { useState, useEffect, useContext } from "react";
import {AuthContext} from "../../context/AuthProvider"
import Card from "../../components/admin/Card/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic, faUsers, faMoneyBillWave } from "@fortawesome/free-solid-svg-icons";
import DashboardGraph from "../../components/admin/Barchart";
import Spinner from "../../components/UI/Spinner";
import ErrorModal from "../../components/UI/Error"
import TopCharts from "../../components/admin/TopCharts/TopCharts";
import { userService, pricingService, musicService, transactionService } from "../../services";

const AdminDashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [cardData, setCardData] = useState([]); 
  const [chartData, setChartData] = useState({}); 
const [topCharts, setTopCharts]= useState({})
const [error, setError]= useState(false)
const {user}=useContext(AuthContext)
  useEffect(() => {
    const getData = async () => {
      try {   
        setError(false)
        const [userStat, musicStat, pricingStat, transactionStat, topArtistes, recentMusic, topStreams] = await Promise.all([
          userService.userStatistics(),
          musicService.getSiteTotalMusic(),
          pricingService.allPricingPlans(),
          transactionService.transactionsStatistics(),
          musicService.getSiteHighestMusicUploaders(),
          musicService.recentMusic(),
          musicService.topStreamMusic()
        ])
        setTopCharts({topArtistes:topArtistes.result, topStreams:topStreams, recentMusic:recentMusic})
        const cards = [
          {
            title: "Users",
            icon: <FontAwesomeIcon icon={faUsers} size="3x" className="z-0 text-gray-600 absolute top-8 right-3" />,
            subMenu: [
              { name: "ALL", number: userStat.all, url: "users/all" },
              { name: "USERS", number: userStat.users, url: "users/users" },
              { name: "ADMIN", number: userStat.admin, url: "users/admin" },
            ],
          },
          {
            title: "Music",
            icon: <FontAwesomeIcon icon={faMusic} size="3x" className="z-0 text-gray-600 absolute top-8 right-3" />,
            subMenu: [
              { name: "ALL", number: musicStat.all, url: "music/all" },
              { name: "NEW", number: musicStat.newMusic, url: "music/new" },
              { name: "SEEN", number: musicStat.seenMusic, url: "music/seen" },
            ],
          },
          {
            title: "Transactions",
            icon: <FontAwesomeIcon icon={faMoneyBillWave} size="3x" className="z-0 text-gray-600 absolute top-8 right-3" />,
            subMenu: [
              { name: "ALL", number: transactionStat.all, url: "transactions/all" },
              { name: "NEW", number: transactionStat.newTransactions, url: "transactions/new" },
              { name: "SEEN", number: transactionStat.seenTransactions, url: "transactions/seen" },
            ],
          },
          {
            title: "Plans",
            icon: <FontAwesomeIcon icon={faMoneyBillWave} size="3x" className="z-0 text-gray-600 absolute top-8 right-3" />,
            subMenu: [
              { name: "ALL", number: pricingStat.length, url: "plans" },
            ],
          },
        ];

        setChartData({
          user: userStat.all,
          music: musicStat.all,
          transaction: transactionStat.all,
          plans: pricingStat.length,
        });

        setCardData(cards);
      } catch (error) {
        setError(true)
        console.error("Error fetching data:", error);
      } finally {
          setIsLoading(false);
      }
    };

    getData();
  }, []);

  const pieData = [
    { name: "Users", value: chartData.user || 0 },
    { name: "Music", value: chartData.music || 0 },
    { name: "Transactions", value: chartData.transaction || 0 },
    { name: "Plans", value: chartData.plans || 0 },
  ];

  const barData = [
    { name: "Users", value: chartData.user || 0 },
    { name: "Music", value: chartData.music || 0 },
    { name: "Transactions", value: chartData.transaction || 0 },
    { name: "Plans", value: chartData.plans || 0 },
  ];

  if (error)
    return (
      <ErrorModal
        isOpen={error}
        onClose={() => setError(false)}
        title={`Error Fetching Data`}
        message={
          `There is error while trying to fetch your dashboard data. Please check your internet contivities and refresh this page to try again`
        }
      />
    );

  return (
    <>
      {isLoading ? (
        <div className="h-[60vh] grid place-items-center">
          <Spinner />
        </div>
      ) : (
        <div className="bg-gray-300 p-4 h-full mix-blend-multiply">
          <h2 className="text-4xl -mb-2 text-gray-600 text-center">
            Welcome Admin - <span className="text-red-900 text-2xl capitalize">{user.username}</span>
          </h2>

          <div className="">
            {cardData && cardData.map((cardDetails) => (
              <div key={cardDetails.title} className="mb-2">
                <Card details={cardDetails} />
              </div>
            ))}
          </div>

          <h1 className="text-3xl text-red-900 font-bold mt-6">
            Statistics Diagrams
          </h1>

          <DashboardGraph pieData={pieData} barData={barData} />
          <TopCharts topChartData={topCharts} />
        </div>
      )}
    </>
  );
};

export default AdminDashboard;